module.exports = __webpack_public_path__ + "media/components/assets/external-2ccf125ab336e0ad5e0ee8897eb3446f.svg";